import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import ContentModule from "../../modules/content_module";

import "./ServiceOption.scss";
import { indexOf } from "lodash";

const ServiceOption = ({Module, GQLPage, service_option, setSerivceOption}) => {

    const handleChage = (e) =>{
        if(e.target.checked){
            setSerivceOption([...service_option, e.target.value])
        } else{
            var set_service = service_option.length > 0 && service_option.filter((item) => item !== e.target.value);
            setSerivceOption(set_service)
        }
    }

    return (
        <React.Fragment>
            <section className="service_option_wrapper" id={Module.id}>
            <Container>
                <Row>
                    <Col>
                        <div className="service_heading">
                            <h3>{Module?.title}</h3>
                            <p>{Module?.content}</p>
                        </div>

                        {Module?.service_options?.length > 0 &&
                        <div className="service_inner">
                            {Module?.service_options?.map((item, index) => {
                                return(
                                    <div className="service_options">
                                        <input type="checkbox" value={item.option_label+" - £"+item.option_price} name="service_option" onChange={handleChage} /> 
                                        <label>{item.option_label} <b>£{item.option_price}</b></label>
                                    </div>
                                )
                            })
                            }
                        </div>
                        }
                    </Col>
                </Row>
            </Container>
            </section>

        </React.Fragment>
    );
};
export default ServiceOption;